import React from 'react';
import { StyleSheet } from 'react-native';
import LineGraph from '../../../../graphs/LineGraph';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import TrafficIcon16 from '../../../16pxIcons/TrafficIcon16';
import { ChartDataPoint } from '../../../../graphs/axisUtils';

interface FootfallGraphProps {
  lineGraphData: ChartDataPoint[],
  alternateLineGraphData?: ChartDataPoint[],
}

const FootfallGraph = ({
  lineGraphData, alternateLineGraphData,
}: FootfallGraphProps) => {
  const filteredData: number[] = lineGraphData?.map((point: ChartDataPoint) => point.value)
    .filter((value: number) => value >= 0) ?? [];
  const count: number = Math.round(
    filteredData.reduce((total: number, value: number) => total + value, 0) / filteredData.length,
  );

  return <SpaceUtilizationWidget
    icon={<TrafficIcon16 />}
    label='Average occupancy'
    tooltipText='Shows foot traffic for each time period during the selected date range'
    title='Footfall'
    unit='ppl'
    content={<LineGraph
      style={[styles.lineGraph, !!alternateLineGraphData && styles.lineGraphWithLegend]}
      title='Attendance'
      noTitle
      alternateTitle='Queue'
      alternateData={alternateLineGraphData}
      chartData={lineGraphData}
      horizontalTickCount={7}
      showLegend={!!alternateLineGraphData}
    />}
    {...{ count }}
  />;
};

const styles = StyleSheet.create({
  lineGraph: {
    marginTop: -80,
  },
  lineGraphWithLegend: {
    marginBottom: -12,
  },
});

export default FootfallGraph;
